module.exports = __webpack_public_path__ + "img/unknown.e13446b3.png";